import { citizensOverviewAreaPathName } from '../citizen/authority/citizen-authority-area-pathnames';

export const forumAreaPathName = 'forum';

export const forumAreaPath = `${citizensOverviewAreaPathName}/${forumAreaPathName}`;
export const forumBasePath = `/${forumAreaPath}`;

export const forumMyChatsPathName = 'mine-beskeder';
export const forumAllChatsPathName = 'alle-beskeder';
export const forumNewsPathName = 'nyheder';
export const forumNudgePathName = 'nudge';
export const forumSettingsPathName = 'indstillinger';

export const forumAreaTitle = 'Forum';
export const forumMyChatsTabLabel = 'Mine beskeder';
export const forumAllChatsTabLabel = 'Alle beskeder';
export const forumNewsTabLabel = 'Nyheder';
export const forumNudgeTabLabel = 'Nudge';
export const forumSettingsTabLabel = 'Indstillinger';
